import { render, staticRenderFns } from "./BrokersTopRightChartsContainer.vue?vue&type=template&id=0fd0e8d0&scoped=true&"
import script from "./BrokersTopRightChartsContainer.vue?vue&type=script&lang=js&"
export * from "./BrokersTopRightChartsContainer.vue?vue&type=script&lang=js&"
import style0 from "./BrokersTopRightChartsContainer.vue?vue&type=style&index=0&id=0fd0e8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0e8d0",
  null
  
)

export default component.exports